import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import './TooltipContent.scss';
import { tooltipContentContainerId } from './TooltipContentContainer';

let errorLogged = false;

export class TooltipContent extends React.Component<Props> {
	private readonly container: HTMLElement | null;

	constructor(props: Props) {
		super(props);
		this.container = document.getElementById(tooltipContentContainerId);
	}
	
	render() {
		if (this.container) {
			return ReactDOM.createPortal(<div ref={this.props.tooltipRefCb} className="tooltip-content">{this.props.content}{this.props.renderContent?.()}</div>, this.container);
		} else {
			if (!errorLogged) {
				console.error?.('Unable to find the tooltip container. Please make sure it is rendered somewhere in the app.')
				errorLogged = true;
			}
			
			return null;
		}
	}
}

interface Props {
	content?: string | nundefined;
	renderContent?: () => ReactElement;
    tooltipRefCb: (elm: HTMLDivElement) => void;
}
